import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { isBrowser } from '@zapier/checkout/src/utils';
import { ApolloInjection } from '@zapier/checkout/src/types';

export const currentUserQuery = gql`
  query currentUser {
    currentUser: currentUserV2 {
      id
    }
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentAccountId = ({
  skip = false,
  useQuery = defaultUseQuery,
}: Props = {}) => {
  const { data, error, loading: isLoadingCurrentUser } = useQuery(
    currentUserQuery,
    {
      skip,
    }
  );

  const response = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading: isLoadingCurrentUser,
  };

  if (!data?.currentUser || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
